import Main from './components/Main';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Main />
      <br />
      <Footer />
    </div>
  );
}

export default App;